<template>
  <div>
  <!-- MAIN -->
  <div class="breadcrumbs ace-save-state" id="breadcrumbs">
    <ul class="breadcrumb">
      <li>
        <i class="ace-icon fa fa-home home-icon"></i>
        <a href="#/">ダッシュボード</a>
      </li>
      <li class="active">ユーザー一覧</li>
    </ul><!-- /.breadcrumb -->
  </div>
  <div class="page-header">
    <div class="checkbox">
      <label class="checkbox-box">
        <input name="scorp" type="checkbox" class="ace userId" checked="checked" @click="addRomoveScorp('userId', 'userId')">
        <span class="lbl">ユーザーID</span>
      </label>
      <label class="checkbox-box">
        <input name="scorp" type="checkbox" class="ace name" checked="checked" @click="addRomoveScorp('name', 'name')">
        <span class="lbl">ユーザー名</span>
      </label>
      <label class="checkbox-box">
        <input name="scorp" type="checkbox" class="ace furigana" checked="checked" @click="addRomoveScorp('furigana', 'furigana')">
        <span class="lbl">ユーザー名ふりがな</span>
      </label>
      <label class="checkbox-box">
        <input name="scorp" type="checkbox" class="ace option1" checked="checked" @click="addRomoveScorp('option1', 'option1')">
        <span class="lbl">備考.1</span>
      </label>
      <label class="checkbox-box">
        <input name="scorp" type="checkbox" class="ace option2" checked="checked" @click="addRomoveScorp('option2', 'option2')">
        <span class="lbl">備考.2</span>
      </label>
    </div>
    <span class="input-icon search-box">
      <input type="text" placeholder="選択項目にチェックして検索" class="nav-search-input" id="nav-search-input" autocomplete="off">
      <i class="ace-icon fa fa-search nav-search-icon"></i>
    </span>
    <button class="btn-cusstom green-btn" type="button" @click="search()">検索</button>
    <button v-if="selectedUserId.length>0" class="btn-cusstom black-btn" type="button" href="#process" data-toggle="modal" @click="resetStatus()">チェックしたユーザーを無効化</button>
  </div><!-- /.page-header -->
  <!-- END MAIN -->
  <div class="page-content">
    <div class="alert alert-danger" v-if="errorMessageLogs!==''">
      {{ errorMessageLogs }}
    </div>
    <div id="loading" v-if="loading"><div class="loadingMsg"></div></div>
    <div class="scroll-data-content">
        <div class="pull-right">
          <a class="option_button" data-toggle="collapse" data-parent="#accordion" href="#collapseOne" aria-expanded="false">表示オプション&nbsp;
            <i class="bigger-110 ace-icon fa fa-angle-down" data-icon-hide="ace-icon fa fa-angle-up" data-icon-show="ace-icon fa fa-angle-down"></i>
          </a>
        </div>
        <div class="clearfix" style="clear:both">
          <div id="accordion">
            <div class="panel-collapse collapse" id="collapseOne" aria-expanded="false" style="height: 0px;">
              <div class="panel-body">
                <div class="control-group">
                  <label class="control-label bolder blue display_block">表示項目</label>
                  <div class="checkbox table_items">
                    <label>
                      <input name="user_id" type="checkbox" class="ace" disabled checked>
                      <span class="lbl"> ユーザーID</span>
                    </label>
                  </div>
                  <div class="checkbox table_items">
                    <label>
                      <input name="user_name" type="checkbox" @click="ShowHideColumn" value="name" class="ace" v-model="checkedColumnNames">
                      <span class="lbl"> ユーザー名</span>
                    </label>
                  </div>
                  <div class="checkbox table_items">
                    <label>
                      <input name="user_furigana" type="checkbox" class="ace" @click="ShowHideColumn" value="furigana" v-model="checkedColumnNames">
                      <span class="lbl">ユーザー名ふりがな</span>
                    </label>
                  </div>
                  <div class="checkbox table_items">
                    <label>
                      <input name="user_permistion" type="checkbox" class="ace" @click="ShowHideColumn" value="isAdmin" v-model="checkedColumnNames">
                      <span class="lbl">組織管理権限</span>
                    </label>
                  </div>
                  <div class="checkbox table_items">
                    <label>
                      <input name="user_isphoneadmin" type="checkbox" class="ace" @click="ShowHideColumn" value="isPhoneAdmin" v-model="checkedColumnNames">
                      <span class="lbl">ゲート設定権限</span>
                    </label>
                  </div>
                  <div class="checkbox table_items">
                    <label>
                      <input name="user_sharekeybevalid" type="checkbox" class="ace" @click="ShowHideColumn" value="shareKeyBeValid" v-model="checkedColumnNames">
                      <span class="lbl">鍵共有権限</span>
                    </label>
                  </div>
                  <div class="checkbox table_items">
                    <label>
                      <input name="user_status" type="checkbox" class="ace" @click="ShowHideColumn" value="status" v-model="checkedColumnNames">
                      <span class="lbl"> ステータス</span>
                    </label>
                  </div>
                  <div class="checkbox table_items">
                    <label>
                      <input name="user_option1" type="checkbox" class="ace" @click="ShowHideColumn" value="option1" v-model="checkedColumnNames">
                      <span class="lbl">備考.1</span>
                    </label>
                  </div>
                  <div class="checkbox table_items">
                    <label>
                      <input name="user_option2" type="checkbox" class="ace" @click="ShowHideColumn" value="option2" v-model="checkedColumnNames">
                      <span class="lbl">備考.2</span>
                    </label>
                  </div>
                  <div class="checkbox table_items">
                    <label>
                      <input name="user_registered" type="checkbox" class="ace" @click="ShowHideColumn" value="registered" v-model="checkedColumnNames">
                      <span class="lbl">登録日</span>
                    </label>
                  </div>
                  <div class="checkbox table_items">
                    <label>
                      <input name="user_updated" type="checkbox" class="ace" @click="ShowHideColumn" value="updated" v-model="checkedColumnNames">
                      <span class="lbl">更新日</span>
                    </label>
                  </div>
                </div>
                <div class="control-group">
                  <label class="control-label bolder blue display_block">ページことに表示する項目</label>
                  <select id="pageSizeOptions" class="first-child last-child" @change="handleSizeChange" v-model="selected">
                    <option v-for="pageSize in pageSizeOptions" v-bind:value="pageSize" v-bind:key="pageSize">
                    {{ pageSize }} 件
                    </option>
                  </select>
                  <div class="checkbox table_items">
                    <label>
                      <input type="checkbox" class="ace" checked v-model="notLoadAllDataUser" @click="reLoadData()">
                      <span class="lbl">有効なデーターのみ表示</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <table id="simple-table" class="table  table-bordered table-hover dataTable" v-if="list!=null">
          <thead>
            <tr>
              <th class="center">
                <label class="pos-rel">
                  <input type="checkbox" class="ace" v-model="selectAll">
                  <span class="lbl"></span>
                </label>
              </th>
              <th id="user_id" class="user_id sorting" @click="sort('userId', 'user_id')">ユーザーID</th>
              <th id="user_name" class="user_name sorting" @click="sort('name', 'user_name')" v-bind:class="{'none': checkColumnShowHide('name')}">ユーザー名</th>
              <th id="user_furigana" class="user_furigana sorting" @click="sort('furigana', 'user_furigana')" v-bind:class="{'none': checkColumnShowHide('furigana')}">ユーザー名ふりがな</th>
              <th id="user_permistion" class="center user_permistion sorting" @click="sort('isAdmin', 'user_permistion')" v-bind:class="{'none': checkColumnShowHide('isAdmin')}">組織管理権限</th>
              <th id="user_isphoneadmin" class="center user_isphoneadmin sorting" @click="sort('isPhoneAdmin', 'user_isphoneadmin')" v-bind:class="{'none': checkColumnShowHide('isPhoneAdmin')}">ゲート設定権限</th>
              <th id="user_sharekeybevalid" class="center user_sharekeybevalid sorting" @click="sort('shareKeyBeValid', 'user_sharekeybevalid')" v-bind:class="{'none': checkColumnShowHide('shareKeyBeValid')}">鍵共有権限</th>
              <th id="user_status" class="center user_status sorting" @click="sort('isValid', 'user_status')" v-bind:class="{'none': checkColumnShowHide('status')}" >ステータス</th>
              <th id="user_option1" class="user_option1 sorting" @click="sort('option1', 'user_option1')" v-bind:class="{'none': checkColumnShowHide('option1')}">備考.1</th>
              <th id="user_option2" class="user_option2 sorting" @click="sort('option2', 'user_option2')" v-bind:class="{'none': checkColumnShowHide('option2')}">備考.2</th>
              <th id="user_registered" class="user_registered sorting center" @click="sort('registered', 'user_registered')" v-bind:class="{'none': checkColumnShowHide('registered')}">登録日</th>
              <th id="user_updated" class="user_updated sorting center" @click="sort('updated', 'user_updated')" v-bind:class="{'none': checkColumnShowHide('updated')}">更新日</th>
            </tr>
          </thead>
          <tbody v-for="(item, index) in list" :key="index">
            <tr v-bind:class="{'selected': rowSelected(item.userId)}" :id="item.userId">
              <td class="center">
                <label class="pos-rel">
                  <input type="checkbox" class="ace" :value="item.userId" v-model="selectedUserId">
                  <span class="lbl"></span>
                </label>
              </td>
              <td class="user_id" @click="showdetail" style="word-wrap:break-word">
                {{item.userId}}
              </td>
              <td class="user_name" @click="showdetail" v-bind:class="{'none': checkColumnShowHide('name')}">
                {{item.name}}
              </td>
              <td class="user_furigana" @click="showdetail" v-bind:class="{'none': checkColumnShowHide('furigana')}">{{item.furigana}}</td>
              <td class="center user_permistion" @click="showdetail" v-bind:class="{'none': checkColumnShowHide('isAdmin')}">
                <span v-if="item.isAdmin">管理者</span>
                <span v-else >ユーザー</span>
              </td>
              <td class="center user_isphoneadmin" @click="showdetail" v-bind:class="{'none': checkColumnShowHide('isPhoneAdmin')}">
                <span v-if="item.isPhoneAdmin">有効</span>
                <span v-else >無効</span>
              </td>
              <td class="center user_sharekeybevalid" @click="showdetail" v-bind:class="{'none': checkColumnShowHide('shareKeyBeValid')}">
                <span v-if="item.shareKeyBeValid">有効</span>
                <span v-else >無効</span>
              </td>
              <td class="center user_status" @click="showdetail" v-bind:class="{'none': checkColumnShowHide('status')}">
                <span v-if="item.isValid">有効</span>
                <span v-else >無効</span>
              </td>
              <td class="user_option1" @click="showdetail" v-bind:class="{'none': checkColumnShowHide('option1')}">
                {{item.option1}}
              </td>
              <td class="user_option2" @click="showdetail" v-bind:class="{'none': checkColumnShowHide('option2')}">
                {{item.option2}}
              </td>
              <td class="user_registered center" @click="showdetail" v-bind:class="{'none': checkColumnShowHide('registered')}">
                {{converDateShort(item.registered)}}
              </td>
              <td class="user_updated center" @click="showdetail" v-bind:class="{'none': checkColumnShowHide('updated')}">
                {{ converDateShort(item.updated) }}
              </td>
            </tr>
            <tr class="detail-row">
              <td v-bind:colspan ="columnCount">
                <app-user-detail v-bind:item="item" v-bind:isAdmin="isAdmin"></app-user-detail>
              </td>
            </tr>
          </tbody>
        </table>
        <table id="simple-table" class="table  table-bordered table-hover dataTable" v-else>
          <thead>
            <tr>
              <th class="center">
                <label class="pos-rel">
                  <input type="checkbox" class="ace">
                  <span class="lbl"></span>
                </label>
              </th>
              <th>ユーザーID</th>
              <th>ユーザー名</th>
              <th>ユーザー名ふりがな</th>
              <th>権限</th>
              <th>ステータス</th>
            </tr>
          </thead>
          <tbody>
            <tr><td colspan="6">{{message}}</td></tr>
          </tbody>
        </table>
    </div><!-- /.row -->
    <div class="row pd-t-10">
      <div class="col-xs-12">
        <div class="dataTables_paginate paging_simple_numbers" v-if="pages>0">
          <paginate
            :page-count="pages"
            :page-range="3"
            :margin-pages="2"
            :click-handler="handleCurrentChange"
            :prev-text="'<<'"
            :next-text="'>>'"
            :container-class="'pagination'"
            :page-class="'page-item'">
          </paginate>
        </div>
      </div>
    </div>
  </div>
  <!-- プロフィールModal -->
  <div id="process" class="modal fade" tabindex="-1">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
          <h3 class="smaller lighter frofile-title no-margin">ユーザーを無効化</h3>
        </div>
        <div class="modal-body">
          <span class="progress-question">チェックしたユーザーを一括無効化します、よろしいですか？</span>
          <div class="progress" v-bind:class="{'progress-striped':!success , active:!success, hide:!success}">
            <div class="progress-bar" :style="progressWidth">
            <span>{{ Math.round(progress) }}%</span>
            </div>
          </div>
          <span class="success-label" v-if="successUser>0">{{countUser}}件中{{successUser}}件を無効化しました。</span>
          <div v-if="errorMessage.length>0">
          <span class="error-box-title">無効化失敗</span>
          <div class="error-box">
            <template v-for="item in errorMessage">
              <p v-html="item" :key="item"></p>
            </template>
          </div>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn btn-sm btn-success pull-right" style="width:100px" data-dismiss="modal" v-if="success">OK</button>
          <button class="btn btn-sm btn-danger pull-right" style="width:100px" v-if="!success" :disabled="isDisabled" @click="updateAllStatus()">実行</button>
        </div>
      </div><!-- /.modal-content -->
    </div><!-- /.modal-dialog -->
  </div>
  <a href="javascript:void(0)" class="float" id="menu-share">
    <i class="fa fa-plus my-float"></i>
  </a>
  <ul class="add_btn_list">
    <li>
      <router-link :to="{ name: 'useradd'}" class="adduser">
        <i class="ace-icon fa fa-users my-float"></i>
      </router-link>
      <div class="label-container">
        <div class="label-text">新規ユーザー登録</div>
        <i class="fa fa-play label-arrow"></i>
      </div>
    </li>
    <li>
      <router-link :to="{ name: 'userimport'}" class="adduserExport">
        <i class="ace-icon glyphicon glyphicon-upload my-float"></i>
      </router-link>
      <div class="label-container-export">
        <div class="label-text">CSVインポートでユーザー登録</div>
        <i class="fa fa-play label-arrow"></i>
      </div>
    </li>
  </ul>
  </div>
</template>

<script>
import * as Config from '../../config'
import moment from 'moment'
import UserDetail from './UserDetail.vue'

export default {
  data () {
    return {
      list: null,
      errorMessageLogs: '',
      message: 'データー取得中',
      checkedColumnNames: [
        'name',
        'furigana',
        'isAdmin',
        'isPhoneAdmin',
        'shareKeyBeValid',
        'status',
        'option1',
        'option2',
        'registered',
        'updated'
      ],
      notLoadAllDataUser: true,
      scorp: ['userId', 'name', 'furigana', 'option1', 'option2'],
      pages: 0,
      error: null,
      pageSizeOptions: [25, 50, 100, 1000],
      listQuery: {
        currPage: 1,
        pageSize: 100
      },
      progress: 0,
      selected: 100,
      selectedUserId: [],
      success: false,
      loading: false,
      isDisabled: false,
      errorMessage: [],
      successUser: 0,
      exeCount: 0,
      percent: 0,
      errorName: '',
      columnCount: 12,
      countUser: 0,
      isAdmin: 'false'
    }
  },
  components: {
    appUserDetail: UserDetail
  },
  watch: {
    'progress': 'checkProgress',
    'checkedColumnNames': 'updateChecked',
    exeCount: function (newVal, oldVal) {
      var vm = this
      if (newVal > 0 && newVal < vm.countUser) {
        vm.updateStatus(this.selectedUserId[newVal], vm.percent, newVal)
      } else if (newVal > 0 && newVal === vm.countUser) {
        this.exeCount = 0
        this.getList()
      }
    }
  },
  created () {
    if (typeof localStorage.notLoadAllDataUser === 'undefined') {
      localStorage.setItem('notLoadAllDataUser', 'yes')
    }
    if (typeof localStorage.pageSizeUserList === 'undefined') {
      localStorage.setItem('pageSizeUserList', 100)
      this.selected = localStorage.pageSizeUserList
    } else {
      this.selected = localStorage.pageSizeUserList
    }
    if (typeof localStorage.listUserAddSortKey === 'undefined') {
      localStorage.setItem('listUserAddSortKey', 'userId')
    }
    if (typeof localStorage.listUserAddSortName === 'undefined') {
      localStorage.setItem('listUserAddSortName', 'desc')
    }
    if (typeof localStorage.checkedUserList === 'undefined') {
      localStorage.setItem('checkedUserList', this.checkedColumnNames)
    } else {
      var tempData = []
      this.checkedColumnNames.forEach(function (item) {
        if (localStorage.checkedUserList.indexOf(item) !== -1) {
          tempData.push(item)
        }
      })
      this.checkedColumnNames = tempData
    }
    this.getList()
  },
  mounted () {
    var vm = this
    vm.isAdmin = localStorage.isAdmin
    $('#nav-search-input').keyup(function (e) {
      if (e.keyCode === 13) {
        vm.search()
      }
    })
    this.columnCount = this.checkedColumnNames.length + 2
    if (localStorage.notLoadAllDataUser === 'yes') {
      this.notLoadAllDataUser = true
    } else {
      this.notLoadAllDataUser = false
    }
  },
  computed: {
    progressWidth: function () {
      return 'width:' + this.progress + '%'
    },
    selectAll: {
      get: function () {
        return this.list ? this.selectedUserId.length === this.list.length : false
      },
      set: function (value) {
        var selectedUserId = []
        if (value) {
          this.list.forEach(function (item) {
            selectedUserId.push(item.userId)
          })
        }
        this.selectedUserId = selectedUserId
      }
    }
  },
  methods: {
    reLoadData () {
      if (localStorage.notLoadAllDataUser === 'yes') {
        localStorage.setItem('notLoadAllDataUser', 'no')
      } else {
        localStorage.setItem('notLoadAllDataUser', 'yes')
      }
      this.pages = 0
      this.listQuery.currPage = 1
      this.getList()
    },
    updateChecked () {
      localStorage.setItem('checkedUserList', this.checkedColumnNames)
      this.columnCount = this.checkedColumnNames.length + 2
    },
    checkColumnShowHide (columnName) {
      if (localStorage.checkedUserList.indexOf(columnName) !== -1) {
        return false
      } else {
        return true
      }
    },
    converDateShort (t) {
      return moment(new Date(t * 1000)).format('YYYY/MM/DD')
    },
    // ユーザー詳細を開く
    showdetail: function (e) {
      e.preventDefault()
      $(e.target).closest('tr').next().toggleClass('open')
      $(e.target).closest('tr').next().find('.panel-title a').addClass('collapsed')
      $(e.target).closest('tr').next().find('.panel-title i').removeClass('fa-angle-down')
      $(e.target).closest('tr').next().find('.panel-title i').addClass('fa-angle-right')
      $(e.target).closest('tr').next().find('div.panel-collapse ').removeClass('in')
    },
    // 実行状態チェック
    checkProgress () {
      if (Math.round(this.progress) === 100) {
        this.success = true
        this.selectedUserId = []
      }
    },
    // チェックしたユーザーを無効化すり前にリセット
    resetStatus () {
      $('.progress').addClass('hide')
      $('.progress-question').html('チェックしたユーザーを無効化しますか？')
      this.progress = 0
      this.success = false
      this.exeCount = 0
      this.isDisabled = false
      this.errorMessage = []
      this.successUser = 0
      this.countUser = 0
    },
    // 行にチェックする
    rowSelected (userId) {
      if (jQuery.inArray(userId, this.selectedUserId) !== -1) {
        return true
      } else {
        return false
      }
    },
    // チェックしたユーザーを無効化
    updateStatus (userId, percent, i) {
      var vm = this
      this.$http.put(Config.USERS_LIST_API + '/' + encodeURIComponent(userId), {isValid: false})
        .then(response => {
          vm.progress += percent
          vm.successUser++
          vm.exeCount++
        })
        .catch((error) => {
          this.progress += percent
          vm.exeCount++
          switch (error.status) {
            case 400:
              this.errorName = '入力したパラメーターが誤っています。入力内容をご確認ください。'
              break
            case 403:
              this.errorName = 'アクセス情報が不正です。ログインし直してからやり直してください。'
              break
            case 404:
              this.errorName = '該当するデーターがありません。'
              break
            case 500:
              this.errorName = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
              break
            case 503:
              this.errorName = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
              break
            default:
              this.errorName = 'アクセス情報が不正です。ログインし直してからやり直してください。'
              break
          }
          var rowstatus = userId + '>><span>' + this.errorName + '</span>'
          this.$set(this.errorMessage, i, rowstatus)
        })
    },
    updateAllStatus () {
      var vm = this
      vm.isDisabled = true
      if (this.selectedUserId.length > 0) {
        this.countUser = this.selectedUserId.length
        $('.progress').removeClass('hide')
        $('.progress-question').html('処理状況')
        vm.percent = (100 / this.selectedUserId.length)
        vm.updateStatus(this.selectedUserId[0], vm.percent, 0)
      } else {
        alert('少なくてもユーザーを１つ選んでください。')
      }
    },
    // 検索項目チェンジ
    addRomoveScorp (classname, scorpname) {
      if ($('.' + classname).prop('checked')) {
        this.scorp.push(scorpname)
      } else {
        this.scorp.splice($.inArray(scorpname, this.scorp), 1)
      }
    },
    resetView () {
      $('#simple-table').find('tr.detail-row').removeClass('open')
      $('div.panel-collapse').removeClass('in')
      $('a.accordion-toggle').addClass('collapsed')
      $('a.accordion-toggle i').addClass('fa-angle-right')
      $('a.accordion-toggle i').removeClass('fa-angle-down')
    },
    // 検索
    search () {
      this.loading = true
      var apiLink = ''
      this.errorMessageLogs = ''
      if (this.scorp.length > 0) {
        this.resetView()
        window.scrollTo(0, 0)
        this.listQuery.currPage = 1
        this.pages = 0
        var keyword = $('.nav-search-input').val()
        keyword = keyword.replace(/\s/g, ',')
        keyword = encodeURIComponent(keyword)
        if (localStorage.notLoadAllDataUser === 'yes') {
          apiLink = Config.USERS_LIST_API + '?limit=' + localStorage.pageSizeUserList + '&page=' + this.listQuery.currPage + '&keyword=' + keyword + '&scorp=' + this.scorp + '&sortKey=' + localStorage.listUserAddSortName + ':' + localStorage.listUserAddSortKey + '&isValid=true'
        } else {
          apiLink = Config.USERS_LIST_API + '?limit=' + localStorage.pageSizeUserList + '&page=' + this.listQuery.currPage + '&keyword=' + keyword + '&scorp=' + this.scorp + '&sortKey=' + localStorage.listUserAddSortName + ':' + localStorage.listUserAddSortKey
        }
        this.$http.get(apiLink)
          .then(response => {
            if (response.body.maxRecords > 0) {
              this.loading = false
              this.pages = Math.ceil((response.body.maxRecords) / localStorage.pageSizeUserList)
              this.list = response.body.users
              console.log(response)
            } else {
              this.loading = false
              this.list = null
              this.pages = 0
              this.message = '該当するデーターがありません。'
            }
          })
          .catch((error) => {
            this.loading = false
            this.list = null
            this.pages = 0
            this.message = '該当するデーターがありません。'
            switch (error.status) {
              case 400:
                this.errorMessageLogs = '入力したパラメーターが誤っています。入力内容をご確認ください。'
                break
              case 403:
                this.errorMessageLogs = 'アクセス情報が不正です。ログインし直してからやり直してください。'
                break
              case 404:
                this.errorMessageLogs = '該当するデーターがありません。'
                break
              case 500:
                this.errorMessageLogs = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
                break
              case 503:
                this.errorMessageLogs = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
                break
              default:
                this.errorMessageLogs = 'アクセス情報が不正です。ログインし直してからやり直してください。'
                break
            }
          })
      } else {
        alert('少なくても検索項目を１つ選んでください。')
        this.loading = false
      }
    },
    // ソート
    sort (sortkey, elementname) {
      this.loading = true
      if ($('#' + elementname).hasClass('sorting_asc')) {
        $('#simple-table>thead>tr>th').removeClass('sorting_asc')
        $('#simple-table>thead>tr>th').removeClass('sorting_desc')
        $('#' + elementname).removeClass('sorting_asc')
        $('#' + elementname).addClass('sorting_desc')
        localStorage.setItem('listUserAddSortName', 'desc')
        localStorage.setItem('listUserAddSortKey', sortkey)
      } else {
        $('#simple-table>thead>tr>th').removeClass('sorting_asc')
        $('#simple-table>thead>tr>th').removeClass('sorting_desc')
        $('#' + elementname).removeClass('sorting_desc')
        $('#' + elementname).addClass('sorting_asc')
        localStorage.setItem('listUserAddSortName', 'asc')
        localStorage.setItem('listUserAddSortKey', sortkey)
      }
      this.getList()
    },
    // １ページに表示する項目数
    handleSizeChange () {
      this.listQuery.pageSize = $('#pageSizeOptions').val()
      localStorage.setItem('pageSizeUserList', this.listQuery.pageSize)
      this.listQuery.currPage = 1
      this.pages = 0
      this.getList()
    },
    // ページネーションチェンジ
    handleCurrentChange (val) {
      this.selectedUserId = []
      this.listQuery.currPage = val
      this.getList()
      $('#simple-table').find('tr.detail-row').removeClass('open')
      window.scrollTo(0, 0)
    },
    // コラム表示する
    ShowHideColumn: function (e) {
      var $tbl = $('#simple-table')
      var colToHide = $tbl.find('.' + $(e.target).attr('name'))
      $(colToHide).toggle()
    },
    // ユーザー一覧
    getList () {
      this.loading = true
      var apiLink = ''
      this.errorMessageLogs = ''
      this.resetView()
      if (this.list !== null) {
        var keyword = $('.nav-search-input').val()
        keyword = keyword.replace(/\s/g, ',')
        keyword = encodeURIComponent(keyword)
      } else {
        keyword = ''
      }
      if (localStorage.notLoadAllDataUser === 'yes') {
        apiLink = Config.USERS_LIST_API + '?limit=' + localStorage.pageSizeUserList + '&page=' + this.listQuery.currPage + '&keyword=' + keyword + '&scorp=' + this.scorp + '&sortKey=' + localStorage.listUserAddSortName + ':' + localStorage.listUserAddSortKey + '&isValid=true'
      } else {
        apiLink = Config.USERS_LIST_API + '?limit=' + localStorage.pageSizeUserList + '&page=' + this.listQuery.currPage + '&keyword=' + keyword + '&scorp=' + this.scorp + '&sortKey=' + localStorage.listUserAddSortName + ':' + localStorage.listUserAddSortKey
      }
      this.$http.get(apiLink)
        .then(response => {
          if (response.body.maxRecords > 0) {
            this.loading = false
            this.pages = Math.ceil((response.body.maxRecords) / localStorage.pageSizeUserList)
            this.list = response.body.users
            console.log(response)
          } else {
            this.list = null
            this.pages = 0
            this.loading = false
            this.message = '該当するデーターがありません。'
          }
        })
        .catch((error) => {
          this.loading = false
          this.list = null
          this.pages = 0
          this.message = '該当するデーターがありません。'
          switch (error.status) {
            case 400:
              this.errorMessageLogs = '入力したパラメーターが誤っています。入力内容をご確認ください。'
              break
            case 403:
              this.errorMessageLogs = 'アクセス情報が不正です。ログインし直してからやり直してください。'
              break
            case 404:
              this.errorMessageLogs = '該当するデーターがありません。'
              break
            case 500:
              this.errorMessageLogs = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
              break
            case 503:
              this.errorMessageLogs = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
              break
            default:
              this.errorMessageLogs = 'アクセス情報が不正です。ログインし直してからやり直してください。'
              break
          }
        })
    }
  }
}
</script>

<style>
.checkbox label, .radio label {
  padding-left: 10px!important
}
.checkbox-box{
  margin-right: 15px
}
.edit-bottom,.delete-bottom{
  width: 100%;
  margin-bottom: 15px
}
.fa-6{
  font-size: 3em;
}
.fa-3{
  font-size: 2em;
}
.table>tbody>tr>td{
  vertical-align: middle;
  padding: 5px;
  font-size: 16px;
}
.dataTables_paginate .pagination {
  margin: 0;
}
.table-bordered>tbody>tr>td{
  border-right:3px solid #fff;
}
.label-sm {
  padding: 10px;
  font-size: 16px;
  line-height: 1;
  height: auto;
}
.table-detail .profile-info-name{
  width: 195px
}
.device{
  margin-top: 50px;
  border-top: 2px solid #ccc
}
.table-detail .accordion-style1.panel-group .panel-heading .accordion-toggle.collapsed{
  font-size: 18px
}
.table-detail .accordion-style1.panel-group .panel-heading .accordion-toggle{
  font-size: 18px
}
.add-buttom{
  margin-bottom: 10px
}
.modal-content .form-horizontal .control-label{
  text-align: left;
}
.chosen-container-single .chosen-single{
  border-radius: 0px;
  height: 35px;
  font-size: 16px;
  line-height: 35px!important;
}
.chosen-container-single{
  width: 100%!important
}
.chosen-container{
  margin-bottom: 10px
}
.dataTable>thead>tr>th[class*=sorting_]{
  color: #707070
}
.modal-content .form-horizontal .control-label{
  text-align: left;
}
.chosen-container-single .chosen-single{
  border-radius: 0px;
  height: 35px;
  font-size: 16px;
  line-height: 35px!important;
}
.chosen-container-single{
  width: 100%!important
}
.chosen-container{
  margin-bottom: 10px
}
.dataTable>thead>tr>th[class*=sorting_]{
  color: #707070
}
</style>



// WEBPACK FOOTER //
// src/views/user/UserList.vue